import AccountCreation from "@/components/signup/account-creation";
import { LoomOverlayTemplate } from "@/components/signup/layouts";
import { useFeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { useIsMobile } from "@/utils/useIsMobile";

import {
    InputSubmitButton,
    GetStartedHeading,
    Headings,
    GetStartedText,
    FreeForTenUsersText
} from "../../components";
import { FreeSubheading } from "../components/free-subheading";

export const LoggedOutLoom = () => {
    const isMobile = useIsMobile(800);

    useFeatureExposed("gwp-7282-loom-lofi-signup", "Test", {
        conditions: [!isMobile],
        metadata: {
            userType: "logged-out"
        }
    });

    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    return (
        <LoomOverlayTemplate size="sm">
            {team26VisualUpdates ? (
                <Headings
                    main={<GetStartedText productName="Loom" />}
                    sub={<FreeForTenUsersText />}
                />
            ) : (
                <>
                    <GetStartedHeading productName="Loom" />
                    <FreeSubheading />
                </>
            )}
            <AccountCreation Input={<InputSubmitButton />} Submit={null} />
        </LoomOverlayTemplate>
    );
};
